export const INITIALISE_APP = 'GLOBAL/APP/INITIALISE'
